import { useMutation } from '@tanstack/react-query';
import {
  ApproveTransferRequestEntity,
  ManualApproveTransferRequestDto,
  TransferWithEvidenceService,
} from 'services/openapi';

export type ManualApproveTransferRequestVariables = {
  id: string;
  variables: ManualApproveTransferRequestDto;
};

export const useManualApproveTransferRequestMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      ApproveTransferRequestEntity,
      Error,
      ManualApproveTransferRequestVariables
    >({
      mutationFn: ({ id, variables }: ManualApproveTransferRequestVariables) =>
        TransferWithEvidenceService.transferWithEvidenceControllerManualApprove(
          id,
          variables,
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
